import React from "react";
import MenuItem, { MenuItemProps } from "./MenuItem";

type LinksProps = {
  links: (MenuItemProps & { _key?: string })[];
  variant?: "mega" | "legacy";
};
const Links: React.FC<LinksProps> = ({ links, variant = "mega" }) => {
  return (
    <React.Fragment>
      {links.map((subSubItem) => (
        <MenuItem key={subSubItem._key} {...subSubItem} variant={variant} />
      ))}
    </React.Fragment>
  );
};

export default Links;
